module.exports = __webpack_public_path__ + "pic/62.37098f56.png";